import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { jwtDecode } from 'jwt-decode';
import { analytics } from './firebase';
import { logEvent, setUserId } from 'firebase/analytics';

interface B2CToken {
  sub: string;
  oid?: string;
  email?: string;
  [key: string]: any;
}

export const useFirebaseUserTracking = () => {
  const { instance } = useMsal();

  useEffect(() => {
    const account = instance.getActiveAccount();

   // Ensure account and idToken are available
    if (!account || !account.idToken) {
      return;
    } 

    try {
      const decoded = jwtDecode<B2CToken>(account.idToken);
      const userId = decoded.sub;

      if (analytics && userId) {
         setUserId(analytics, userId);

         logEvent(analytics, 'user_logged_in', { 
            userId
         });
      }
    } catch (err) {
      console.error('Failed to decode ID token:', err);
    }
  }, [instance]);
};
